import { apiClient } from "./client";
import { LoginRequest } from "../types";

export const authApi = {
  login: async (credentials: LoginRequest): Promise<void> => {
    await apiClient.post("/auth/login", credentials);
  },

  logout: async (): Promise<void> => {
    await apiClient.post("/auth/logout");
  },

  checkAuth: async (): Promise<{ email: string }> => {
    const response = await apiClient.get<{ email: string }>("/auth/me");
    return response.data;
  },
};
